import React from 'react'
import type { FlattenSimpleInterpolation } from 'styled-components'
import { css } from 'styled-components'

import { createMixin } from '@vfuk/core-mixins'
import type { Theme } from '@vfuk/core-themes'

import type { LoadingSpinnerTheme, AnimationStyleMixin } from './LoadingSpinner.theme.types'

const animationStyle = createMixin(
  (theme, width: number, height: number, strokeColor: string): FlattenSimpleInterpolation =>
    css`
      @supports (display: grid) {
        display: inline-flex;
      }
      display: none;
      width: ${height}px;
      height: ${height}px;
      align-items: center;
      justify-content: center;
      @keyframes passingWay {
        0% {
          stroke-dashoffset: 115;
          stroke-dasharray: 0, 115;
          stroke-width: 0;
        }
        20% {
          stroke-width: 4;
        }
        45% {
          stroke-dashoffset: 0;
          stroke-dasharray: 115, 0;
          stroke-width: 4;
        }
        55% {
          stroke-dashoffset: 0;
          stroke-dasharray: 115, 0;
          stroke-width: 4;
        }
        80% {
          stroke-width: 4;
        }
        100% {
          stroke-dashoffset: 115;
          stroke-dasharray: 0, 115;
          stroke-width: 0;
        }
      }
      svg {
        width: ${width}px;
        height: ${height}px;
        > path {
          stroke-width: 4;
          stroke: ${strokeColor};
          animation: passingWay 3s ease infinite both;
        }
      }
    `,
) as AnimationStyleMixin

const defaultTheme = (theme: Theme): LoadingSpinnerTheme => {
  const svg = (
    <svg width='34' height='44' viewBox='0 0 34 44' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M25.0866 15.9962C22.7495 14.7514 21.4788 14.5559 18.482 14.057C18.482 8.56832 21.9782 3.07968 21.9782 3.07968C21.9782 3.07968 16.551 4.00486 12.5013 6.57245C9.73842 8.32411 7.14499 10.9895 5.50887 13.558C2.40439 18.0002 1.84278 22.5264 2.03315 26.2641C2.24667 35.0364 9.56734 41.5797 17.5622 41.5797C25.557 41.5797 32 35.3206 32 27.2828C32 21.6166 29.359 18.3599 25.3801 16.1557'
        stroke='#E60000'
      />
    </svg>
  )
  return {
    appearance: {
      primary: {
        color: theme.color.monochrome6.default,
        inverse: {
          color: theme.inverseColor.monochrome6.default,
        },
      },
      secondary: {
        color: theme.color.primary1.default,
        inverse: {
          color: theme.inverseColor.primary1.default,
        },
      },
    },
    svg,
    size: {
      1: {
        width: 13,
        height: 18,
      },
      2: {
        width: 17,
        height: 23,
      },
      3: {
        width: 24,
        height: 30,
      },
      4: {
        width: 28,
        height: 36,
      },
      5: {
        width: 34,
        height: 44,
      },
    },
    animationStyle,
  }
}

export default defaultTheme
